﻿import { PanelHeader, PanelTitle } from 'components/secondaryMarket/shared/status/Panel';
import type { ReactNode } from 'react';
import { DlpOrderStatus } from 'state/secondaryMarket/dlpOrder/order/order.model';

interface OrderPlacedHeaderProps {
  summary: string;
  hint: string | null;
  children?: ReactNode;
  status?: DlpOrderStatus;
}

export function OrderPlacedHeader({ summary, hint, status, children }: OrderPlacedHeaderProps) {
  return (
    <PanelHeader color={status === 'ORDER_STALE' ? 'warning' : 'info'} discreet>
      {children}
      <PanelTitle className="flex-grow-1" e2e="placedOrderLabelSummary">
        {summary}
      </PanelTitle>
      {hint !== null && <span className="align-self-end fs-6 py-2">{hint}</span>}
    </PanelHeader>
  );
}
